<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-book"></i></div>
      <div>
        Cahier de note par élève
        <div class="page-title-subheading">Notes d'un élève, toutes matières</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>

<div  class="card mb-3">
  <div class="card-body py-3">
    <div class="row g-3 align-items-end">
      <div class="col-12 col-md-4">
        <label for="" class="form-label mb-0">Choisir la classe</label>
        <select class="form-select form-select-sm" (change)="loadCompositions1($event)" >
            <option selected disabled></option>
            <option *ngFor="let classroom of classrooms" [value]="classroom?.id">{{classroom?.name}}</option>
        </select>
      </div>
      <div class="col-12 col-md-4">
        <label for="" class="form-label mb-0">Choisir la période</label>
        <select class="form-select form-select-sm" [(ngModel)]="periodId" name="periodId" (change)="loadCompositions2($event)">
            <option selected disabled></option>
            <option *ngFor="let p of periods" [value]="p?.id">{{p?.name}}</option>
        </select>
      </div>
      <div class="col-12 col-md-4">
        <label for="" class="form-label mb-0">Choisir un apprenant</label>
        <select class="form-select form-select-sm" name="search_text" [(ngModel)]="search_text" >
            <option selected disabled></option>
            <option *ngFor="let sac of students" [value]="sac?.student?.lastname">{{sac?.student?.lastname}} {{sac?.student?.firstname}}</option>
        </select>
      </div>
    </div>
  </div>
</div>
<div class="text-center mb-3">
    <button  *ngIf="data.length!=0 " [disabled]="loading" (click)="getPdf()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
        Exporter le cahier de note en PDF <app-loading [isVisible]="loading"></app-loading> </button>
</div>
<div class="container" *ngIf="search_text!=''">
    <div class="card mb-3" *ngFor="let d of data  | sampleSearch:search_text:'bulletins' ; let i=index">
        <div class="d-flex justify-content-between p-3">
            <ul>
                <li><strong>Nom: </strong>{{d.lastname}}</li>
                <li><strong>Prénoms: </strong>{{d.firstname}}</li>
                <li><strong>Classe: </strong>{{d.classroom}}</li>
            </ul>
            <div class="align-self-center">
                <button *ngIf="d?.details[i].notes" (click)="getPdf2(i)" [disabled]="loading" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light"> Exporter le bulletin</button>
            </div>
        </div>   
        <hr>
        <div class="card-body">
            <p>{{data!.length}} élément(s)</p>
            <div class="table-responsive">
            <table class="table table-sm table-bordered table-striped">
                <thead>
                    <tr>
                        <th>Matière</th>
                        <th *ngFor="let c of d.compositions">{{c.label}}</th>
                    </tr>
                  
                </thead>
                <tbody>
                    <tr *ngFor="let dt of d?.details ; let j=index">
                        <td >
                            <strong>{{dt.course}}</strong><br>
                            <small>{{dt.professor}}</small>
                        </td>
                        <ng-container *ngIf="dt.notes; else notNote">
                            <td *ngFor="let n of dt.notes">
                                {{n}}
                             </td>
                        </ng-container>
                        <ng-template #notNote>
                            <td *ngFor="let c of d.compositions"></td>
                        </ng-template>
                        
                       
                    </tr>
                </tbody>
            </table>
            </div>
        </div>
    </div>
</div>


<ng-template #contentPDF let-offcanvas>
	<div class="offcanvas-header">
    
		<h4 class="offcanvas-title">Visualiseur de fichier</h4>
		<button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body">
        <ngx-extended-pdf-viewer [src]="pdfSrc"
        style="width: 100%; height: 100%"
        ></ngx-extended-pdf-viewer>
	</div>
</ng-template>